import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from '@shared/services';

import { StoreListComponent } from './store-list/store-list.component';
import { StoreRequestListComponent } from './store-request-list/store-request-list.component';
import { StoreComponent } from './store.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    component: StoreComponent,
    children: [
      {
        path: 'store-list',
        component: StoreListComponent,
        data: {
          title: 'STORE',
          isShowOnMenu: true,
          subgroup: 'STORE',
          permissions: [
            'store_new_m',
            'store_new_req_v',
            'store_v',
            'store_eq',
            'store_locksale',
            'store_terminate',
            'store_edit_m',
            'store_app',
            'store_edit_req_v'
          ]
        }
      },
      {
        path: 'store-request-list',
        component: StoreRequestListComponent,
        canActivate: [AuthGuardService],
        data: {
          subgroup: 'STORE',
          permissions: ['store_new_m', 'store_new_req_v', 'store_edit_m', 'store_edit_req_v', 'store_app']
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StoreRouting {}
